import type { UIViewInjectedProps } from '@uirouter/react';

import { Attachments } from '@/components/attachments';
import { AttachmentType } from '@/types/enums';

export const WaybillAttachments = ({ transition }: UIViewInjectedProps) => {
  const params = {
    transition,
    apiEntity: 'Waybill',
    paramId: 'waybillId',
    attachmentType: AttachmentType.Waybill,
    closeRoute: 'base-layout.waybills',
  };

  return (
    <Attachments<cyrian.api.waybills.Waybill & { attachments: cyrian.api.attachments.Attachment[] }> {...params} />
  );
};
